<template>
  <svg
    width="22"
    height="22"
    fill="#000000"
    viewBox="0 0 141.76195 142.66132"
    version="1.1"
    id="svg2683"
    sodipodi:docname="linkedin-logo.svg"
    inkscape:version="1.2.2 (732a01da63, 2022-12-09)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
    <path
      d="M 0,10.21937 C 0,4.5768893 4.6901226,0 10.475944,0 H 131.28602 c 5.78562,0 10.47593,4.5768893 10.47593,10.21937 v 122.22258 c 0,5.64438 -4.69031,10.21936 -10.47593,10.21936 H 10.475944 C 4.6901226,142.66131 0,138.08633 0,132.44195 Z"
      style="
        fill: #009eda;
        fill-opacity: 1;
        fill-rule: nonzero;
        stroke: none;
        stroke-width: 8.15063;
      "
      id="path14"
      inkscape:connector-curvature="0" />
    <path
      d="M 42.972435,119.42231 V 55.002734 H 21.560562 V 119.42231 Z M 32.266401,46.207334 c 7.466757,0 12.114175,-4.946707 12.114175,-11.128654 -0.139156,-6.321094 -4.647418,-11.130549 -11.972534,-11.130549 -7.324365,0 -12.113228,4.809455 -12.113228,11.130549 0,6.181947 4.64647,11.128654 11.832054,11.128654 h 0.139157 z"
      style="
        fill: #ffffff;
        fill-opacity: 1;
        fill-rule: evenodd;
        stroke: none;
        stroke-width: 8.15063;
      "
      id="path28"
      inkscape:connector-curvature="0" />
    <path
      d="M 54.820307,119.42231 H 76.231992 V 83.447691 c 0,-1.925308 0.139156,-3.848702 0.704544,-5.225011 1.54787,-3.846798 5.070995,-7.830844 10.986065,-7.830844 7.747922,0 10.847281,5.90745 10.847281,14.567502 V 119.42231 H 120.17985 V 82.485042 c 0,-19.786799 -10.56345,-28.993954 -24.650774,-28.993954 -11.551066,0 -16.62205,6.45644 -19.439477,10.854149 h 0.142966 V 55.002734 H 54.820878 c 0.280977,6.044704 0,64.419576 0,64.419576 z"
      style="
        fill: #ffffff;
        fill-opacity: 1;
        fill-rule: evenodd;
        stroke: none;
        stroke-width: 8.15063;
      "
      id="path30"
      inkscape:connector-curvature="0" />
  </svg>
</template>
